import dynamic from 'next/dynamic';

export { GenericTicketsGrid } from './GenericTicketsGrid';
export { GenericTicketsFilters } from './GenericTicketsFilters';

const GenericTicketSidebar = dynamic(() =>
  import('./GenericTicketSidebar/GenericTicketSidebar')
);

const GenericTicketDetails = dynamic(() =>
  import('./GenericTicketDetails/GenericTicketDetails')
);

export { GenericTicketSidebar, GenericTicketDetails };
